<template>
  <div :class="['content-title', sizeComp, textAlignComp, weightComp]" :style="colorComp">
    <nt-tag :tag="tag"> 
      <slot></slot>
    </nt-tag>
  </div>
</template>

<script>
export default {
  name: 'content-title',
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    textAlign: {
      type: String,
      default: 'center'
    },
    color: {
      type: String,
      default: '#FFF'
    },
    weight: {
      type: String,
      default: 'normal'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    colorComp() {
      return `color: ${this.color}`
    },
    sizeComp() {
      return `content-title--${this.size}`
    },
    textAlignComp() {
      return `content-title--text-align-${this.textAlign}`
    },
    weightComp() {
      return `content-title--weight-${this.weight}`
    }
  }
}
</script>

<style lang="scss" scoped>
$base-font-xs: 1.750em; // 28
$base-font-sm: 2.500em; // 40
$base-font-md: 3.250em; // 52
$base-font-df: 4.000em; // 64
$base-font-lg: 4.750em; // 76
$base-font-xl: 5.500em; // 88
$base-font-xxl: 6.250em; // 100

.content-title {
  color: #FFF;
  // display: flex;
  // flex-wrap: wrap;
  // flex: initial;
  line-height: 1em;
  letter-spacing: -1px;
  // font-weight: 700;

  &--extrasmall {
    font-size: $base-font-xs;
  }

  &--small {
    font-size: 32px;

    @media (min-width: 768px) {
      font-size: 36px
    }

    @media (min-width: 992px) {
      font-size: 40px
    }

    @media (min-width: 1200px) {
      font-size: 44px
    }

    @media (min-width: 1600px) {
      font-size: $base-font-sm
    }
  }

  &--medium {
    font-size: 36px;

    @media (min-width: 768px) {
      font-size: 40px
    }

    @media (min-width: 992px) {
      font-size: 44px
    }

    @media (min-width: 1200px) {
      font-size: 48px
    }

    @media (min-width: 1600px) {
      font-size: $base-font-md
    }
  }

  &--default {
    font-size: 40px;

    @media (min-width: 768px) {
      font-size: 44px;
    }

    @media (min-width: 992px) {
      font-size: 48px;
    }

    @media (min-width: 1200px) {
      font-size: 52px;
    }

    @media (min-width: 1600px) {
      font-size: $base-font-df
    }
  }

  &--large {
    font-size: 44px;

    @media (min-width: 768px) {
      font-size: 48px
    }

    @media (min-width: 992px) {
      font-size: 52px
    }

    @media (min-width: 1200px) {
      font-size: 56px
    }

    @media (min-width: 1600px) {
      font-size: $base-font-lg
    }
  }

  &--extralarge {
    font-size: 48px;

    @media (min-width: 768px) {
      font-size: 52px
    }

    @media (min-width: 992px) {
      font-size: 56px
    }

    @media (min-width: 1200px) {
      font-size: 60px
    }

    @media (min-width: 1600px) {
      font-size: $base-font-xl
    }
  }

  &--xxlarge {
    font-size: 52px;

    @media (min-width: 768px) {
      font-size: 56px
    }

    @media (min-width: 992px) {
      font-size: 60px
    }

    @media (min-width: 1200px) {
      font-size: 64px
    }

    @media (min-width: 1600px) {
      font-size: $base-font-xxl
    }
  }

  // &--center {
  //   justify-content: center;
  // }

  // &--start {
  //   justify-content: flex-start;
  // }

  // &--end {
  //   justify-content: flex-end;
  // }

  &--text-align-center {
    text-align: center;
  }

  &--text-align-left {
    text-align: left;
  }

  &--text-align-right {
    text-align: right;
  }

  &--text-align-justify {
    text-align: justify;
  }

  &--weight-lighter {
    & > * {
      font-weight: lighter;
    }
  }

  &--weight-normal {
    & > * {
      font-weight: normal;
    }
  }

  &--weight-bold {
    & > * {
      font-weight: bold;
    }
  }
}
</style>